/**
 * SUP-023: Support APA contribution analytics (enhancement-only; cart works without JS).
 * Event catalog: docs/features/support-contributions/reporting-classification.md
 */
(function () {
  "use strict";

  var NAV_CTAS = {
    support_contribution: true,
    "support-apa-nav": true,
    "support-apa-account": true,
    "support-apa-promo": true,
  };

  var SURFACE_TO_SOURCE = {
    header_primary: "header",
    drawer: "drawer",
    footer: "footer",
    homepage: "homepage",
    account_dashboard: "account",
    support_page: "support_page",
    cart_page: "cart_prompt",
    checkout: "checkout",
  };

  function track(event, props) {
    var payload = props || {};
    if (window.PMA && window.PMA.analytics && typeof window.PMA.analytics.track === "function") {
      window.PMA.analytics.track(event, payload);
      return;
    }
    try {
      document.dispatchEvent(
        new CustomEvent("pma:analytics", {
          detail: { event: event, payload: payload },
          bubbles: true,
        }),
      );
    } catch (_err) {
      /* enhancement-only */
    }
  }

  function memberState() {
    if (window.PMA_Analytics_Context && window.PMA_Analytics_Context.member_state) {
      return window.PMA_Analytics_Context.member_state;
    }
    if (document.body) {
      return document.body.getAttribute("data-pma-member-state") || "unknown";
    }
    return "unknown";
  }

  function navAreaToSurface(navArea) {
    var area = String(navArea || "").toLowerCase();
    if (area === "primary" || area === "header_primary") return "header_primary";
    if (area === "drawer") return "drawer";
    if (area === "footer") return "footer";
    if (area === "homepage") return "homepage";
    if (area === "account" || area === "account_dashboard") return "account_dashboard";
    return area || "unknown";
  }

  function readCartFlags() {
    var flags = {
      cart_item_count: 0,
      cart_contains_support: false,
      cart_contains_merchandise: false,
      cart_contains_membership: false,
    };
    var meta = document.querySelector("[data-pma-cart-meta]") || document.querySelector(".pma-cart-summary");
    if (meta) {
      flags.cart_item_count = Number(meta.getAttribute("data-cart-item-count") || 0);
      flags.cart_contains_support = meta.getAttribute("data-pma-cart-has-support") === "true";
      flags.cart_contains_merchandise = meta.getAttribute("data-pma-cart-has-merchandise") === "true";
      flags.cart_contains_membership = meta.getAttribute("data-pma-cart-has-membership") === "true";
    }
    return flags;
  }

  function basePayload(extra) {
    var payload = {
      member_state: memberState(),
      support_method: "product",
    };
    var cart = readCartFlags();
    Object.keys(cart).forEach(function (key) {
      payload[key] = cart[key];
    });
    if (extra && typeof extra === "object") {
      Object.keys(extra).forEach(function (key) {
        payload[key] = extra[key];
      });
    }
    return payload;
  }

  function bindSupportForms(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-pma-support-add-form]").forEach(function (form) {
      if (form.getAttribute("data-pma-support-bound") === "true") return;
      form.setAttribute("data-pma-support-bound", "true");

      var button = form.querySelector("button[type='submit']");
      if (button) {
        button.addEventListener(
          "click",
          function () {
            track(
              "pma_support_amount_click",
              basePayload({
                surface: form.getAttribute("data-pma-support-surface") || "support_page",
                source: form.getAttribute("data-pma-support-source") || "support_page",
                amount: form.getAttribute("data-pma-support-amount") || "",
                variant_sku: form.getAttribute("data-pma-support-sku") || "",
                support_method: "product",
              }),
            );
          },
          false,
        );
      }

      /* Track ATC immediately on submit (measurable without waiting on network).
         When JS/fetch is available, also preventDefault and use /cart/add.js so
         failures can emit pma_support_add_to_cart_error. No-JS keeps native POST. */
      form.addEventListener(
        "submit",
        function (event) {
          var payload = basePayload({
            surface: form.getAttribute("data-pma-support-surface") || "support_page",
            source: form.getAttribute("data-pma-support-source") || "support_page",
            amount: form.getAttribute("data-pma-support-amount") || "",
            variant_sku: form.getAttribute("data-pma-support-sku") || "",
            support_method: "product",
          });
          track("pma_support_add_to_cart", payload);
          if (typeof fetch !== "function" || form.getAttribute("data-pma-support-ajax") === "false") {
            return;
          }
          event.preventDefault();
          var body = new FormData(form);
          fetch("/cart/add.js", {
            method: "POST",
            body: body,
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          })
            .then(function (res) {
              if (!res.ok) {
                return res
                  .json()
                  .catch(function () {
                    return {};
                  })
                  .then(function (errBody) {
                    track(
                      "pma_support_add_to_cart_error",
                      Object.assign({}, payload, {
                        status: res.status,
                        message: errBody && errBody.description ? String(errBody.description).slice(0, 120) : "add_failed",
                      }),
                    );
                    throw new Error("support_add_failed");
                  });
              }
              var redirect =
                form.getAttribute("data-pma-support-redirect") ||
                (window.routes && window.routes.cart_url) ||
                "/cart";
              window.location.assign(redirect);
            })
            .catch(function (err) {
              if (String(err && err.message) === "support_add_failed") return;
              track(
                "pma_support_add_to_cart_error",
                Object.assign({}, payload, { message: "network_or_parse_error" }),
              );
            });
        },
        true,
      );
    });
  }

  function trackSurfaceViews() {
    if (document.querySelector("[data-pma-support-amounts]")) {
      track("pma_support_page_view", basePayload({ surface: "support_page", source: "support_page" }));
      track("pma_support_amount_view", basePayload({ surface: "support_page", source: "support_page" }));
    }

    var prompt = document.querySelector("[data-pma-support-cart-prompt]");
    if (prompt) {
      var already = prompt.querySelector("[data-pma-support-already-added]");
      track(
        "pma_support_cart_prompt_view",
        basePayload({ surface: "cart_page", source: "cart_prompt" }),
      );
      if (already) {
        track(
          "pma_support_cart_already_present",
          basePayload({ surface: "cart_page", source: "cart_prompt" }),
        );
      }
    }

    if (document.querySelector("[data-pma-support-apa-account-card]")) {
      track(
        "pma_support_page_view",
        basePayload({ surface: "account_dashboard", source: "account" }),
      );
    }
  }

  function bindNavClicks() {
    document.addEventListener(
      "click",
      function (event) {
        var el = event.target.closest("[data-pma-cta]");
        if (!el) return;
        var cta = String(el.getAttribute("data-pma-cta") || "");
        if (!NAV_CTAS[cta]) return;
        var surface =
          el.getAttribute("data-pma-cta-surface") ||
          navAreaToSurface(el.getAttribute("data-pma-nav-area"));
        var source = SURFACE_TO_SOURCE[surface] || "unknown";
        track(
          "pma_support_nav_click",
          basePayload({
            surface: surface,
            source: source,
            cta: cta,
          }),
        );
      },
      false,
    );
  }

  function bindCartPromptAdds() {
    document.querySelectorAll("[data-pma-support-cart-prompt] [data-pma-support-add-form]").forEach(function (form) {
      form.addEventListener(
        "submit",
        function () {
          track(
            "pma_support_cart_prompt_add",
            basePayload({
              surface: "cart_page",
              source: "cart_prompt",
              amount: form.getAttribute("data-pma-support-amount") || "",
              variant_sku: form.getAttribute("data-pma-support-sku") || "",
            }),
          );
        },
        false,
      );
    });
  }

  function bindCheckoutHooks() {
    document.querySelectorAll("a[href*='/checkout'], button[name='checkout']").forEach(function (el) {
      if (el.getAttribute("data-pma-support-checkout-bound") === "true") return;
      el.setAttribute("data-pma-support-checkout-bound", "true");
      el.addEventListener(
        "click",
        function () {
          var cart = readCartFlags();
          if (!cart.cart_contains_support) return;
          track(
            "pma_support_checkout_started",
            basePayload({ surface: "cart_page", source: "cart_prompt" }),
          );
        },
        false,
      );
    });
  }

  function bindCartRemove() {
    document.addEventListener(
      "click",
      function (event) {
        var removeLink = event.target.closest("a[data-pma-cta='cart_remove']");
        if (!removeLink) return;
        var row = removeLink.closest("[data-pma-line-item]");
        if (!row) return;
        if (row.getAttribute("data-pma-support-line") !== "true") return;
        track(
          "pma_support_removed_from_cart",
          basePayload({
            surface: "cart_page",
            source: "cart_prompt",
            variant_sku: row.getAttribute("data-pma-line-sku") || "",
          }),
        );
      },
      false,
    );
  }

  function bindAnalyticsBridge() {
    document.addEventListener(
      "pma:analytics",
      function (event) {
        var detail = (event && event.detail) || {};
        if (detail.event === "pma_cart_remove" && detail.support_line === true) {
          track(
            "pma_support_removed_from_cart",
            basePayload({
              surface: "cart_page",
              source: detail.source || "cart_prompt",
              variant_sku: detail.variant_sku || "",
            }),
          );
        }
        if (detail.event === "pma_support_add_to_cart_error") {
          track("pma_support_add_to_cart_error", basePayload(detail));
        }
        if (detail.event === "pma_support_purchase_completed") {
          track("pma_support_purchase_completed", basePayload(detail));
        }
      },
      false,
    );
  }

  function bindCheckoutPrompt() {
    var prompt = document.querySelector("[data-pma-support-checkout-prompt]");
    if (!prompt) return;
    track(
      "pma_support_checkout_prompt_view",
      basePayload({ surface: "checkout", source: "checkout", support_method: "checkout_prompt" }),
    );
    prompt.querySelectorAll("[data-pma-support-checkout-prompt-add]").forEach(function (control) {
      control.addEventListener(
        "click",
        function () {
          track(
            "pma_support_checkout_prompt_added",
            basePayload({
              surface: "checkout",
              source: "checkout",
              support_method: "checkout_prompt",
              amount: control.getAttribute("data-pma-support-amount") || "",
            }),
          );
        },
        false,
      );
    });
  }

  function init() {
    bindSupportForms(document);
    bindCartPromptAdds();
    bindNavClicks();
    bindCartRemove();
    bindCheckoutHooks();
    bindCheckoutPrompt();
    bindAnalyticsBridge();
    trackSurfaceViews();

    document.addEventListener(
      "shopify:section:load",
      function (event) {
        if (!event || !event.target) return;
        bindSupportForms(event.target);
        bindCartPromptAdds();
        bindCheckoutHooks();
        bindCheckoutPrompt();
        trackSurfaceViews();
      },
      false,
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
